import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiDropGroupMention } from "@/generated/models/ApiDropGroupMention";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import WaveDropPartTitle from "./WaveDropPartTitle";
import WaveDropPartContent from "./WaveDropPartContent";
import { ImageScale } from "@/helpers/image.helpers";
import type { DropContentPresentation } from "./dropContentPresentation";
interface WaveDropPartDropProps {
  drop: ApiDrop;
  activePart: ApiDropPart;
  havePreviousPart: boolean;
  haveNextPart: boolean;
  isStorm: boolean;
  activePartIndex: number;
  setActivePartIndex: (index: number) => void;
  onQuoteClick: (drop: ApiDrop) => void;
  isEditing?: boolean | undefined;
  isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedGroups?: ApiDropGroupMention[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  isCompetitionDrop?: boolean | undefined;
  mediaImageScale?: ImageScale | undefined;
  mediaContainerHeightClassName?: string | undefined;
  fullWidthMedia?: boolean | undefined;
  readonly onLinkCardActionsActiveChange?: ((href: string, active: boolean) => void) | undefined;
  readonly contentPresentation?: DropContentPresentation | undefined;
  readonly embedPath?: readonly string[] | undefined;
  readonly quotePath?: readonly string[] | undefined;
  readonly embedDepth?: number | undefined;
  readonly maxEmbedDepth?: number | undefined;
}
const WaveDropPartDrop: React.FC<WaveDropPartDropProps> = t0 => {
  const $ = _c(29);
  const {
    drop,
    activePart,
    havePreviousPart,
    haveNextPart,
    isStorm,
    activePartIndex,
    setActivePartIndex,
    onQuoteClick,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    isCompetitionDrop: t3,
    mediaImageScale: t4,
    mediaContainerHeightClassName,
    fullWidthMedia: t5,
    onLinkCardActionsActiveChange,
    contentPresentation: t6,
    embedPath,
    quotePath,
    embedDepth,
    maxEmbedDepth
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const isCompetitionDrop = t3 === undefined ? false : t3;
  const mediaImageScale = t4 === undefined ? ImageScale.AUTOx450 : t4;
  const fullWidthMedia = t5 === undefined ? false : t5;
  const contentPresentation = t6 === undefined ? "default" : t6;
  const showStandaloneTitle = contentPresentation !== "quorumCompact";
  let t7;
  if ($[0] !== drop.title || $[1] !== showStandaloneTitle) {
    t7 = showStandaloneTitle && <WaveDropPartTitle title={drop.title} />;
    $[0] = drop.title;
    $[1] = showStandaloneTitle;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== activePart || $[4] !== activePartIndex || $[5] !== contentPresentation || $[6] !== drop || $[7] !== embedDepth || $[8] !== embedPath || $[9] !== fullWidthMedia || $[10] !== haveNextPart || $[11] !== havePreviousPart || $[12] !== isCompetitionDrop || $[13] !== isEditing || $[14] !== isSaving || $[15] !== isStorm || $[16] !== maxEmbedDepth || $[17] !== mediaContainerHeightClassName || $[18] !== mediaImageScale || $[19] !== onCancel || $[20] !== onLinkCardActionsActiveChange || $[21] !== onQuoteClick || $[22] !== onSave || $[23] !== quotePath || $[24] !== setActivePartIndex) {
    t8 = <WaveDropPartContent mentionedUsers={drop.mentioned_users} mentionedGroups={drop.mentioned_groups} mentionedWaves={drop.mentioned_waves} referencedNfts={drop.referenced_nfts} wave={drop.wave} activePart={activePart} havePreviousPart={havePreviousPart} haveNextPart={haveNextPart} isStorm={isStorm} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onQuoteClick={onQuoteClick} isEditing={isEditing} isSaving={isSaving} onSave={onSave} onCancel={onCancel} drop={drop} isCompetitionDrop={isCompetitionDrop} mediaImageScale={mediaImageScale} mediaContainerHeightClassName={mediaContainerHeightClassName} fullWidthMedia={fullWidthMedia} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} contentPresentation={contentPresentation} embedPath={embedPath} quotePath={quotePath} embedDepth={embedDepth} maxEmbedDepth={maxEmbedDepth} />;
    $[3] = activePart;
    $[4] = activePartIndex;
    $[5] = contentPresentation;
    $[6] = drop;
    $[7] = embedDepth;
    $[8] = embedPath;
    $[9] = fullWidthMedia;
    $[10] = haveNextPart;
    $[11] = havePreviousPart;
    $[12] = isCompetitionDrop;
    $[13] = isEditing;
    $[14] = isSaving;
    $[15] = isStorm;
    $[16] = maxEmbedDepth;
    $[17] = mediaContainerHeightClassName;
    $[18] = mediaImageScale;
    $[19] = onCancel;
    $[20] = onLinkCardActionsActiveChange;
    $[21] = onQuoteClick;
    $[22] = onSave;
    $[23] = quotePath;
    $[24] = setActivePartIndex;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t7 || $[27] !== t8) {
    t9 = <div className="tw-relative tw-flex tw-h-full tw-gap-x-3"><div className="tw-flex tw-h-full tw-w-full tw-flex-col tw-self-center sm:tw-self-start"><div>{t7}{t8}</div></div></div>;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};
export default WaveDropPartDrop;